<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="24">
        <el-col :span="4">
          <el-autocomplete
            class="inline-input"
            v-model="currentShop"
            :fetch-suggestions="queryStoreSearch"
            placeholder="请输入店铺名称"
            @select="storeSearch"
            size="mini"
          ></el-autocomplete>
        </el-col>
        <el-col :span="8">
          <el-date-picker v-model="create_time" type="daterange" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="订单号" v-model="identifier" size="mini"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="6">
          <el-input placeholder="售后单号" v-model="aftersales_bn" size="mini"><el-button slot="append" icon="el-icon-search" @click="aftersalesBnSearch"></el-button></el-input>
        </el-col>
        <el-col :span="6">
          <el-select v-model="aftersales_status" @change="aftersalesStatusSelectHandle" placeholder="售后状态"
           style="width: 100%;" size="mini">
            <el-option
              v-for="(item, index) in aftersalesStatusList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="aftersales_type" @change="TypeHandle" placeholder="请选择售后类型"
           style="width: 100%;" size="mini">
            <el-option
              v-for="(item, index) in aftersalesTypeList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-button type="primary" @click="exportData" round size="mini">导出</el-button>
        <el-popover
          placement="top-start"
          width="200"
          trigger="hover"
          content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </el-row>
      <el-table :data="list" style="width: 100%" :height="wheight-140" v-loading="loading" element-loading-text="数据加载中">
        <el-table-column prop="create_time" width="160" label="创建时间">
          <template slot-scope="scope">
            <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aftersales_bn" width="150" label="售后单号"></el-table-column>
        <el-table-column prop="order_id" width="150" label="订单号"></el-table-column>
        <el-table-column prop="item_name" width="160" label="标题"></el-table-column>
        <el-table-column prop="num" width="100" label="数量"></el-table-column>
        <el-table-column prop="aftersales_status" label="售后类型">
          <template slot-scope="scope">
            <!-- 订单状态 -->
            <el-tag v-if="scope.row.aftersales_type == 'ONLY_REFUND'" type="success" size="mini">仅退款</el-tag>
            <el-tag v-else-if="scope.row.aftersales_type == 'REFUND_GOODS'" size="mini">退货退款</el-tag>
            <el-tag v-else-if="scope.row.aftersales_type == 'EXCHANGING_GOODS'" type="danger" size="mini">换货</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="aftersales_status" label="售后状态">
          <template slot-scope="scope">
            <!-- 订单状态 -->
            <el-tag v-if="scope.row.aftersales_status == '0'" type="success" size="mini">待处理</el-tag>
            <el-tag v-else-if="scope.row.aftersales_status == '1'" size="mini">处理中</el-tag>
            <el-tag v-else-if="scope.row.aftersales_status == '2'" type="danger" size="mini">已处理</el-tag>
            <el-tag v-else-if="scope.row.aftersales_status == '3'" type="danger" size="mini">已驳回</el-tag>
            <el-tag v-else-if="scope.row.aftersales_status == '4'" type="danger" size="mini">已关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
          <router-link :to="{ path: matchHidePage('detail'), query: { aftersales_bn: scope.row.aftersales_bn}}"> <span> 详情</span></router-link>
            <span  style="cursor: pointer" ><a type="primary" @click="remarksShow(scope.row)">备注</a></span>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="remarksName"
        :visible.sync="marks"
        width="40%"
        :before-close="handleClose">
        <el-form ref="form" :model="form2" label-width="80px">
        <el-form-item label="备注信息">
          <el-input type="textarea" v-model="form2.remarks"></el-input>
        </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="marks= false">取 消</el-button>
    <el-button type="primary" @click="subremarks ">确 定</el-button>
  </span>
      </el-dialog>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="params.page"
          :page-sizes="[10,20,50]"
          :total="total_count"
          :page-size="params.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { getDistributorList } from '../../../api/marketing'
  import { getAftersalesList, exportList, reviewAftersales,editRemarks } from '../../../api/aftersales'
  export default {
    data () {
      return {
        currentShop: '',
        loading: false,
        create_time: '',
        params: {
          page: 1,
          pageSize: 20
        },
        aftersalesStatusList: [
          {name: '待处理', value: '0'},
          {name: '处理中', value: '1'},
          {name: '已处理', value: '2'},
          {name: '已驳回', value: '3'}
        ],
        aftersalesTypeList: [
          {name: '仅退款', value: 'ONLY_REFUND'},
          {name: '退货退款', value: 'REFUND_GOODS'},
          {name: '换货', value: 'EXCHANGING_GOODS'}
        ],
        aftersales_type: '',
        aftersales_status: '',
        aftersales_bn: '',
        time_start_begin: '',
        time_start_end: '',
        total_count: 0,
        list: [],
        identifier: '',
        wxShopsList: [],
        // 备注
        marks: false,
        remarksName: '',
        form2: {
          aftersales_bn: '',
          remarks:'',
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      // 备注
      remarksShow(val){
        this.marks=true;
        this.remarksName='售后单号：'+val.aftersales_bn +' 标题：' + val.item_name ;
        this.form2.aftersales_bn=val.aftersales_bn;
        this.form2.remarks=val.remarks;
      },
      handleClose(done){
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      subremarks(){
        editRemarks(this.form2).then(response => {
          if(response.data.data.status){
            this.marks=false;
            this.$message({
              type: 'success',
              message: '备注添加成功！'
            })
            this.getAftersalesList(this.params)
            return
          }else{
            this.$message({
              type: 'error',
              message: '备注添加失败！'
            })
            return
          }


        })
      },
      shopHandle (val) {
        this.currentShop = val
        this.params.shop_id = val
        this.params.page = 1
        this.getParams()
        this.getAftersalesList(this.params)
      },
      TypeHandle (val) {
        this.params.aftersales_type = val
        this.getParams()
        this.getAftersalesList(this.params)
      },
      aftersalesStatusSelectHandle () {
        this.params.aftersales_status = this.aftersales_status
        this.params.page = 1
        this.getParams()
        this.getAftersalesList(this.params)
      },
      search (e) {
        this.params.page = 1
        this.getParams()
        this.getAftersalesList(this.params)
      },
      aftersalesBnSearch() {
        this.getParams()
        this.getAftersalesList(this.params)
      },
      dateChange (val) {
        if (val.length > 0) {
          this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.time_start_begin = ''
          this.time_start_end = ''
        }
        this.params.page = 1
        this.getParams()
        this.getAftersalesList(this.params)
      },
      sourceSearch(item) {
        this.params.source_id = item.source_id
        this.params.page = 1
        this.getParams()
        this.getAftersalesList(this.params)
      },
      handleCurrentChange (val) {
        this.params.page = val
        this.loading = false
        this.getParams()
        this.getAftersalesList(this.params)
      },
      handleSizeChange (pageSize) {
        this.loading = false
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getParams()
        this.getAftersalesList(this.params)
      },
      getParams () {
        this.params.time_start_begin = this.time_start_begin
        this.params.time_start_end = this.time_start_end
        this.params.order_type = this.order_type
        this.params.aftersales_bn = this.aftersales_bn
        this.params.order_id = this.identifier
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
      getAftersalesList(filter) {
        this.loading = true
        getAftersalesList(filter).then(response => {
          this.list = response.data.data.list
          this.total_count = Number(response.data.data.total_count)
          this.loading = false
        })
      },
      querySearch(queryString, cb) {
        var restaurants = this.source_list;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        }
      },
      getStoreList () {
        this.loading = true
        let params = {page: 1, pageSize: 500}
        getDistributorList(params).then(response => {
          if(response.data.data.list) {
            response.data.data.list.forEach(row => {
              this.wxShopsList.push({'value': row.name, 'distributor_id': row.distributor_id})
            })
          }
          this.loading = false
        })
      },
      queryStoreSearch(queryString, cb) {
        var restaurants = this.wxShopsList
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      storeSearch(item) {
        this.params.distributor_id = item.distributor_id
        this.params.page = 1
        this.getParams()
        this.getAftersalesList(this.params)
      },
      exportData () {
          this.getParams()
          this.params.page = 1
          exportList(this.params).then(response => {
              if (response.data.status) {
                  this.$message({
                      type: 'success',
                      message: '已加入执行队列，请在设置-导出列表中下载'
                  })
                  return
              } else if (response.data.url) {
                  this.downloadUrl = response.data.url
                  this.downloadName = response.data.filename
                  this.downloadView = true
              } else {
                  this.$message({
                      type: 'error',
                      message: '没有相关数据可导出'
                  })
              }
          })
      }
    },
    mounted () {
      this.getStoreList()
      this.getAftersalesList(this.params)
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?d4e75bd0